import { keyframes, css } from "styled-components";
import appShellUiVars from "_c/AppShell/ui-vars";

const rippleKeyframes = keyframes`
 to {
    transform: scale3d(4,4,4);
    opacity: 0;
  }
`;
export const rippleMixin = css`
  backface-visibility: hidden;
  perspective: 1000;
  pointer-events: none;
  position: absolute;
  border-radius: 50%;
  opacity: 1;
  transform: scale3d(0, 0, 0);
  will-change: transform;
  animation: ${rippleKeyframes} 650ms linear;
`;

const HEIGHT_MEASUREMENT_INNACURACY = "2px";
export const minViewportHeightMixin = css`
  min-height: 100vh;
  min-height: calc(
    var(--initial-vh, 1vh) * 100 - ${HEIGHT_MEASUREMENT_INNACURACY}
  );
`;

const circSize = "6px";
export const requiredMixin = css`
  ::after {
    content: "";
    display: inline-block;
    position: relative;
    top: -9px;
    margin-left: 2px;
    border-radius: 50%;
    width: ${circSize};
    height: ${circSize};
    min-width: ${circSize};
    min-height: ${circSize};
    background: var(--color-danger);
  }
`;

export const positiveRequiredMixin = css`
  ::after {
    content: "";
    display: inline-block;
    position: relative;
    top: -9px;
    margin-left: 2px;
    border-radius: 50%;
    width: ${circSize};
    height: ${circSize};
    min-width: ${circSize};
    min-height: ${circSize};
    background: ${({ theme }) => theme.color.positive};
  }
`;

export const fabMixin = css`
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 12;
  @media (max-width: ${appShellUiVars.mobileBp}px) {
    right: 10px;
    bottom: 70px;
  }
`;

export const resetButtonMixin = css`
  background: none; /* Removes default background color/gradient */
  color: inherit; /* Inherits text color from parent */
  border: none; /* Removes default border */
  padding: 0; /* Removes default padding */
  font: inherit; /* Inherits font styles from parent */
  cursor: pointer; /* Ensures the cursor remains a pointer */
  outline: inherit; /* Removes outline on focus (be careful with accessibility) */
  -webkit-appearance: none; /* For WebKit browsers (Chrome, Safari) */
  -moz-appearance: none; /* For Mozilla browsers (Firefox) */
  appearance: none; /* Standard property */

  /* You might also want to reset these for more control */
  box-shadow: none; /* Removes default box shadow */
  text-decoration: none; /* Removes any default text decoration */
  display: inline-block; /* Ensures it behaves like a standard inline-block element */
  margin: 0; /* Removes default margins */
`;
